import { useFormik } from 'formik';
import * as yup from 'yup';

import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { yupErrorMsg } from '../../../components/atoms/const';
import api from '../../../components/api';

interface LoginRes {
  'username': string;
  'companyName': string;
  'firstName': string;
  'lastName': string;
  'token': string;
}

function useLogin() {
  const navigate = useNavigate();

  /* state management for react query fetch management */
  const { isLoading, mutate } = useMutation(api.auth.postLogin, {
    // onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      // console.log('login result', res);
      const resData: LoginRes | undefined = res?.data?.data;
      if (resData) {
        sessionStorage.setItem('token', resData.token);
        sessionStorage.setItem('fullName', (`${resData.firstName} ${resData.lastName}`));
        sessionStorage.setItem('isLoggedIn', 'true');
        navigate('/overview');
      }
    },
    onError: (err: Error) => console.log('err', err.message),
  });

  /* form validation */
  /* change required function for showing error massage like you want */
  const yupSchema = yup.object({
    username: yup.string().email(yupErrorMsg.EMAIL_INCORRECT_FORMAT).required(yupErrorMsg.USERNAME_EMPTY),
    password: yup.string().required(yupErrorMsg.PASSWORD_EMPTY),
  });

  /* form handler */
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: yupSchema,
    onSubmit: (values) => {
      mutate(values);
    },
  });

  /* get result from hitting login API */

  return {
    formik, isLoading,
  };
}

export default useLogin;
